/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Patient API
 * API for Patient
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import promiseRetry from "promise-retry";
import { forceRefreshAccessToken } from "@mgdx-libs/firebase";
import * as runtime from "../runtime";
import {
  GetMCCMJAHISSyncJobsResponse,
  GetMCCMJAHISSyncJobsResponseFromJSON,
  GetMCCMJAHISSyncJobsResponseToJSON,
  PatientMCCMJAHISSyncJob,
  PatientMCCMJAHISSyncJobFromJSON,
  PatientMCCMJAHISSyncJobToJSON,
} from "../models";

export interface GetMCCMJAHISSyncJobRequest {
  chainId: number;
  familyAccountId?: number;
  statuses?: Array<GetMCCMJAHISSyncJobStatusesEnum>;
  limit?: number;
  offset?: number;
}

export interface RegisterMCCMJAHISSyncJobRequest {
  chainId: number;
  familyAccountId?: number;
}

/**
 *
 */
export class MccmJahisSyncJobApi extends runtime.BaseAPI {
  /**
   * Get MCCM sync medicine notebook JAHIS jobs
   */
  async getMCCMJAHISSyncJobRaw(
    requestParameters: GetMCCMJAHISSyncJobRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<GetMCCMJAHISSyncJobsResponse>> {
    if (requestParameters.chainId === null || requestParameters.chainId === undefined) {
      throw new runtime.RequiredError(
        "chainId",
        "Required parameter requestParameters.chainId was null or undefined when calling getMCCMJAHISSyncJob."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.familyAccountId !== undefined) {
      queryParameters["family_account_id"] = requestParameters.familyAccountId;
    }

    if (requestParameters.statuses) {
      queryParameters["statuses"] = requestParameters.statuses;
    }

    if (requestParameters.limit !== undefined) {
      queryParameters["limit"] = requestParameters.limit;
    }

    if (requestParameters.offset !== undefined) {
      queryParameters["offset"] = requestParameters.offset;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/patient/medicine-notebooks/{chain_id}/mccm-jahis-sync-jobs`.replace(
          `{${"chain_id"}}`,
          encodeURIComponent(String(requestParameters.chainId))
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => GetMCCMJAHISSyncJobsResponseFromJSON(jsonValue));
  }

  /**
   * Get MCCM sync medicine notebook JAHIS jobs
   */
  async getMCCMJAHISSyncJob(
    requestParameters: GetMCCMJAHISSyncJobRequest,
    initOverrides?: RequestInit
  ): Promise<GetMCCMJAHISSyncJobsResponse> {
    return promiseRetry(
      (retry) =>
        this.getMCCMJAHISSyncJobRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }

  /**
   * Register MCCM sync medicine notebook JAHIS job
   */
  async registerMCCMJAHISSyncJobRaw(
    requestParameters: RegisterMCCMJAHISSyncJobRequest,
    initOverrides?: RequestInit
  ): Promise<runtime.ApiResponse<PatientMCCMJAHISSyncJob>> {
    if (requestParameters.chainId === null || requestParameters.chainId === undefined) {
      throw new runtime.RequiredError(
        "chainId",
        "Required parameter requestParameters.chainId was null or undefined when calling registerMCCMJAHISSyncJob."
      );
    }

    const queryParameters: any = {};

    if (requestParameters.familyAccountId !== undefined) {
      queryParameters["family_account_id"] = requestParameters.familyAccountId;
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.accessToken) {
      const token = this.configuration.accessToken;
      const tokenString = await token("Bearer", []);

      if (tokenString) {
        headerParameters["Authorization"] = `Bearer ${tokenString}`;
      }
    }
    const response = await this.request(
      {
        path: `/patient/medicine-notebooks/{chain_id}/mccm-jahis-sync-jobs`.replace(
          `{${"chain_id"}}`,
          encodeURIComponent(String(requestParameters.chainId))
        ),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides
    );

    return new runtime.JSONApiResponse(response, (jsonValue) => PatientMCCMJAHISSyncJobFromJSON(jsonValue));
  }

  /**
   * Register MCCM sync medicine notebook JAHIS job
   */
  async registerMCCMJAHISSyncJob(
    requestParameters: RegisterMCCMJAHISSyncJobRequest,
    initOverrides?: RequestInit
  ): Promise<PatientMCCMJAHISSyncJob> {
    return promiseRetry(
      (retry) =>
        this.registerMCCMJAHISSyncJobRaw(requestParameters, initOverrides)
          .catch(async (error: Response) => {
            if (error.status === 401) {
              const accessToken = await forceRefreshAccessToken();
              if (accessToken) {
                retry(error);
              }
            }
            throw error;
          })
          .then(async (response) => {
            return await (response as any).value();
          }),
      {
        // The maximum amount of times to retry the operation. Default is 10.
        retries: 5,
        // The exponential factor to use. Default is 2.
        factor: 4,
        // The number of milliseconds before starting the first retry. Default is 1000.
        // minTimeout: 1000,
        // The maximum number of milliseconds between two retries. Default is Infinity.
        // maxTimeout: 60000,
        // Randomizes the timeouts by multiplying with a factor between 1 to 2. Default is false.
        // randomize: false,
      }
    ).catch((error) => {
      throw error;
    });
  }
}

/**
 * @export
 * @enum {string}
 */
export enum GetMCCMJAHISSyncJobStatusesEnum {
  Initialized = "initialized",
  Processing = "processing",
  Synced = "synced",
  Failed = "failed",
}
